import React from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';
import config from 'files/api.js';
import PageLayout from 'views/PageLayout.js';
import Accordion from 'views/Accordion.js';

// Help organized by product, drawn from the owner's manuals.
const SupportPage = () => {

    const products = [
        {
            name: 'Water Sensor',
            topics: [
                { q: 'Installing & placing your sensor', a: 'Place the sensor where water would first appear — under sinks, by the water heater, behind the fridge, near the washer and dishwasher. Secure it with the 2-sided adhesive feet, rubber feet, or the vertical mounting screw included in the box. The Water Sensor is used together with the Smart Hub and the app.' },
                { q: 'Testing your sensor', a: 'Press and release the test button, then confirm the alert on your other devices, in the app, or on your phone. Test the whole network after installation and periodically after that.' },
                { q: 'Understanding freeze alerts', a: 'Along with water, the sensor watches temperature and sounds a freeze alert when it drops below 40°F — an early warning before pipes can freeze and burst.' },
                { q: 'Cleaning & care', a: 'Wipe the exterior and the 23-karat gold sensor with a soft cloth dampened with warm water. Do not use harsh detergents, which can damage the housing and the gold contacts.' },
                { q: 'Range & placement tips', a: 'The radio is tested to about 200 ft (70 m) in open areas. Large metal objects and appliances reduce range, and every sensor also repeats the signal to extend coverage. Re-test after moving large furniture.' },
            ],
        },
        {
            name: 'Smart Hub',
            topics: [
                { q: 'Choosing Ethernet or Wi-Fi', a: 'Ethernet gives the most reliable connection — a 3 ft cord is included. Wi-Fi (2.4 GHz) lets you place the hub more centrally in the home, which improves range to your sensors. Place the Smart Hub as centrally as possible.' },
                { q: 'Adding or removing a device', a: 'Use the app to add a Water Sensor or Bedside Control Center to your network, or to remove one you no longer use.' },
                { q: 'What the status lights mean', a: 'Four illuminated icons show Power, Warning, Wireless, and Fire status. An internal piezo horn provides audible feedback at the hub.' },
                { q: 'A device shows “offline”', a: 'The network shows a device offline if the Smart Hub hasn’t checked in within the last hour. Confirm the Smart Hub is powered on and connected to the internet by Ethernet or Wi-Fi; it will show online again once it checks back in.' },
                { q: 'Test & silence button', a: 'The dual-function button tests the network and silences nuisance alerts. The Smart Hub is AC powered and needs no batteries.' },
            ],
        },
        {
            name: 'Bedside Control Center',
            topics: [
                { q: 'Setting up the shaker & speaker', a: 'Slip the shaker unit under the mattress and place the speaker on the nightstand — a 6 ft cord connects them. Install the Bedside Control Center in a room used for sleeping.' },
                { q: 'How it wakes you', a: 'During an alarm it vibrates the bed and sounds a 520 Hz low-frequency horn tuned at ear level — designed for heavy sleepers, children, and the hearing impaired.' },
                { q: 'Replacing batteries', a: 'The Bedside Control Center is powered by three Duracell DL123 lithium batteries.' },
                { q: 'Testing & silencing', a: 'Use the dual-function test/silence button to test the unit or silence an alert. Four illuminated icons show Power, Warning, Wireless, and Fire status.' },
            ],
        },
    ];

    return (
        <PageLayout
            eyebrow={'Support Center'}
            title={'How can we help?'}
            subtitle={'Setup guides and troubleshooting for every device, straight from the owner’s manuals.'}>

            {products.map((p, index) => (
                <div key={index} style={{ marginBottom: Utils.isMobile() ? 44 : 60 }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, marginBottom: 16 }}>
                        <h2 style={Appearance.textStyles.heading({ fontSize: Utils.isMobile() ? 22 : 28 })}>{p.name}</h2>
                    </div>
                    <Accordion items={p.topics} />
                </div>
            ))}

            {/* Contact */}
            <div style={{
                textAlign: 'center',
                padding: Utils.isMobile() ? '36px 24px' : '48px 40px',
                borderRadius: 20,
                backgroundColor: Appearance.colors.offWhite,
            }}>
                <h3 style={{ ...Appearance.textStyles.subHeading(), marginBottom: 8 }}>{'Need a hand?'}</h3>
                <p style={{ ...Appearance.textStyles.body(), marginBottom: 6 }}>
                    {'Reach our U.S.-based support team directly.'}
                </p>
                <a href={`mailto:${config.store.email}`} style={{ ...Appearance.textStyles.body({ color: Appearance.colors.primary(), fontWeight: 600 }), textDecoration: 'none' }}>
                    {`${config.store.email} · ${config.store.phone}`}
                </a>
            </div>
        </PageLayout>
    );
};

export default SupportPage;
